<template>
  <v-layout row wrap>
     
          <v-container fluid pa-1 pt-3>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-form ref="form" v-model="form_valid">
                
                    <!-- ข้อมูลพนักงาน -->
                    
                      <div slot="header">
                        <h3>{{$t('EmployeeDetails')}}</h3>
                      </div>
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex md12 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex md6 sm6 xs12 text-xs-center hidden-sm-and-up>
                                <v-avatar size="100" :tile="false" aria-readonly @click="''">
                                    <v-icon
                                      size="100"
                                      color="black"
                                      style="cursor: pointer;"
                                      v-if="img == ''"
                                    >far fa-user</v-icon>
                                    <img v-if="img != ''" :src="img">
                                    <input
                                      type="file"
                                      id="file1"
                                      name="image"
                                      ref="file1"
                                      class="upload"
                                      @change="onChangePicture($event,1)"
                                      accept="image/*"
                                      capture
                                      style="display:none"
                                    >
                                  </v-avatar>
                                </v-flex>
                                <v-flex md6 sm6 xs12 px-2>
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('employee_code')"
                                        v-model="form_model.code"
                                        :rules="form_rules.code"
                                        readonly
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('IDcard')"
                                        v-model="form_model.citizen_id"
                                        :rules="form_rules.citizen_id"
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('name')"
                                        v-model="form_model.first_name"
                                        :rules="form_rules.first_name"
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('lastname')"
                                        v-model="form_model.last_name"
                                        :rules="form_rules.last_name"
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('nickname')"
                                        v-model="form_model.nick_name"
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('birthday')"
                                        v-model="form_model.birth_date"
                                        type="date"
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md12 sm12 xs12 pa-1>
                                      <h3>{{$t('gender')}}</h3>
                                      <v-radio-group
                                        v-model="form_model.gender"
                                        :column="false"
                                        hide-details
                                      >
                                        <v-radio :label="$t('male')" value="male"/>
                                        <v-radio :label="$t('female')" value="female"/>
                                      </v-radio-group>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('nationality')"
                                        v-model="form_model.nationality"
                                        hide-details
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('race')"
                                        v-model="form_model.race"
                                        hide-details
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex md6 sm6 xs12 text-xs-center hidden-xs-only>
                                  <v-avatar size="256" :tile="false" aria-readonly @click="''">
                                    <v-icon
                                      size="250"
                                      color="black"
                                      style="cursor: pointer;margin-top:30px;"
                                      v-if="img == ''"
                                    >far fa-user</v-icon>
                                    <img v-if="img != ''" :src="img">
                                    <input
                                      type="file"
                                      id="file1"
                                      name="image"
                                      ref="file1"
                                      class="upload"
                                      @change="onChangePicture($event,1)"
                                      accept="image/*"
                                      capture
                                      style="display:none"
                                    >
                                  </v-avatar>
                                </v-flex>

                                <v-flex xs12 px-2>
                                  <v-textarea
                                    :label="$t('Address')"
                                    v-model="form_model.address"
                                    hide-details
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap px-2>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('TelephoneNumber')"
                                    v-model="form_model.phone_num"
                                    type="phone"
                                    hide-details
                                  />
                                </v-flex>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    label="LINE ID"
                                    v-model="form_model.line_id"
                                    hide-details
                                  />
                                </v-flex>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('email')"
                                    v-model="form_model.email"
                                    hide-details
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                   
                  <!-- ตั้งค่าเข้าสู่ระบบ -->
                   
                      <div slot="header">
                        <h3>{{$t('loginpanel')}}</h3>
                      </div>
                      <v-card>
                        <v-card-text>
                          <!-- Username && Password -->
                          <v-layout row wrap>
                                <v-flex md6 sm6 xs12 px-2>
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field v-if="form_model.user_name == '' || form_model.user_name == null" :label="$t('user_name')" v-model="user_name2"  hide-details/>
                                      <v-text-field v-else :label="$t('user_name')" v-model="form_model.user_name" readonly hide-details/>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('password')"
                                        v-model="form_model.user_password"
                                        hide-details/>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
      
        
          <v-layout row wrap >
            <v-flex xs12 text-xs-right>
              <v-btn
                color="success"
                @click=" onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{  $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        
     
    <!-- Change Salary -->
    <!-- <v-layout row justify-center>
    <v-dialog v-model="Salarydialog" persistent max-width="350">
      <v-card>
        <v-card-title><strong><h3><br><v-icon> fa-info-circle</v-icon>&nbsp;{{$t('Employee_dialog_changesalary')}}</h3></strong></v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs 12 text-xs-center>
            <p text-md-center><br>{{$t('Employee_dialog_changesalaryat')}}</p><strong>" {{$t('Employee_dialog_AdjustmentMenu')}} "</strong>
            </v-flex>
          </v-layout>
         </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="Salarydialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout> -->
    <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="'error'">
      {{ errmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>

     <v-snackbar v-model="snackbar_success" :timeout="3500" :top="'top'" :color="'success'">
      {{ errmsg }}
      <v-btn dark flat @click="snackbar_success = false">X</v-btn>
    </v-snackbar>
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading" persistent width="250">
        <v-card>
          <v-card-text align-center align-content-center justify-center>
            <h4>Processing.....</h4>
            <div class="lds-css ng-scope">
              <div style="width:100%;height:100%" class="lds-pacman">
                <div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
export default {
  data: () => ({
     dialog_loading: false,
    user_name2:"",
    snackbar: false,
    snackbar_success:false,
    errmsg: "",
    Salarydialog : false,
    panel: [true, false,false,false],
    img: "",
    weekend_mon: "0",
    weekend_tue: "0",
    weekend_wed: "0",
    weekend_thu: "0",
    weekend_fri: "0",
    weekend_sat: "0",
    weekend_sun: "0",
    form_model: {
      company_guid: "",
      user_name:"",
      user_password:"",
      code: "",
      name_title: "นาย",
      nick_name: "",
      is_auto_ss: "0",
      is_auto_tax: "0",
      is_training: "0",
      is_special: "1",
      plan_type: "0",
      first_name: "",
      weekends: "",
      holiday_profile: "",
      deduct_ss: 0,
      deduct_tax: 0,
      calworkhour: 8,
      income_craft: 0,
      income_position: 0,
      income_special: 0,
      promptpay_number: "",
      not_cal_time: "0",
      payment_type: 0,
      last_name: "",
      nationality: "",
      emp_type: "0",
      earning_daytype: "0",
      daily_monday: 0,
      daily_tuesday: 0,
      daily_wednesday: 0,
      daily_thursday: 0,
      daily_friday: 0,
      daily_saturday: 0,
      daily_sunday: 0,
      daily_holiday: 0,
      earning_hourtype: "0",
      hour_monday: 0,
      hour_tuesday: 0,
      hour_wednesday: 0,
      hour_thursday: 0,
      hour_friday: 0,
      hour_saturday: 0,
      hour_sunday: 0,
      hour_holiday: 0,
      form_hour_1: 0,
      to_hour_1: 0,
      hourearning_1: 0,
      form_hour_2: 0,
      to_hour_2: 0,
      hourearning_2: 0,
      birth_date: "",
      address: "",
      gender: "male",
      phone_num: "",
      email: "",
      race: "",
      line_id: "",
      citizen_id: "",
      position: "",
      approver: localStorage._usercode,
      start_work_date: "",
      packing_date: "",
      status: "1",
      branch: "",
      faction: "",
      department: "",
      start_salary: 0,
      packing_salary: 0,
      daily_earnings: 0,
      hourly_earnings: 0,
      book_bank: "",
      bank_name: "",
      bank_code: "",
      shift_profile: "",
      conditions_profile: "",
      emp_images: [],
      taxsetting: {
        less_exp_rate: 50,
        less_exp_base: 100000,
        reduce_person: 60000,
        reduce_spouse: 0,
        reduce_child_rate: 0,
        reduce_child_base: 30000,
        reduce_parent_rate: 0,
        reduce_parent_base: 30000,
        reduce_handucap_rate: 0,
        reduce_handucap_base: 30000,
        reduce_insurance_base: 100000,
        reduce_insurance: 0,
        reduce_parent_insurance_base: 15000,
        reduce_parent_insurance: 0,
        reduce_inc_residence_base: 100000,
        reduce_inc_residence: 0,
        reduce_ltf: 0,
        reduce_long_insurance: 0,
        reduce_rmf: 0,
        reduct_name_1: "",
        reduct_name_2: "",
        reduct_name_3: "",
        reduct_name_4: "",
        reduct_name_5: "",
        reduct_name_6: "",
        reduct_name_7: "",
        reduct_name_8: "",
        reduct_name_9: "",
        reduct_name_10: "",
        reduct_value_1: 0,
        reduct_value_2: 0,
        reduct_value_3: 0,
        reduct_value_4: 0,
        reduct_value_5: 0,
        reduct_value_6: 0,
        reduct_value_7: 0,
        reduct_value_8: 0,
        reduct_value_9: 0,
        reduct_value_10: 0
      },
      creator_code: localStorage._usercode
    },
    profilePlan: [],
    profileConditions: [],
    form_rules: {
      code: [v => !!v || "do not empty."],
      first_name: [v => !!v || "do not empty."],
      last_name: [v => !!v || "do not empty."],
      branch: [v => !!v || "do not empty."],
      department: [v => !!v || "do not empty."],
      start_work_date: [v => !!v || "do not empty."],
      citizen_id: [v => !!v || "do not empty."],  
    },
    form_valid: false,
    branch_items: [],
    department_items: [],
    holidayProfile: [],
    pay_items: [
      {
        code: "0",
        name: "เงินโอน"
      },
      {
        code: "1",
        name: "พร้อมเพย์"
      },
      {
        code: "2",
        name: "เงินสด"
      },
      {
        code: "3",
        name: "อื่นๆ"
      }
    ]
  }),
  created: function() {
    this.getEmpDetail(localStorage._empcode);
    this.getProfileBranchList();
    this.getProfileDepartmentList();
    this.getHolidayPlanList();
    this.getProfilePlan();
    this.getProfileConditions();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"])
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    // closeDialog() {
    //   this.$refs.form.reset();
    //   this.$emit("close-dialog");
    // },
    clearForm() {
      this.user_name2 = "",
      this.img = "";
      this.panel = [true, false, false];
      this.weekend_mon = "0";
      this.weekend_tue = "0";
      this.weekend_wed = "0";
      this.weekend_thu = "0";
      this.weekend_fri = "0";
      this.weekend_sat = "0";
      this.weekend_sun = "0";
      this.form_model = {
        company_guid: "",
        user_name:"",
        user_password:"",
        code: "",
        name_title: "นาย",
        nick_name: "",
        is_auto_ss: "0",
        is_auto_tax: "0",
        is_training: "0",
        is_special: "1",
        plan_type: "0",
        first_name: "",
        weekends: "",
        holiday_profile: "",
        deduct_ss: 0,
        deduct_tax: 0,
        calworkhour: 8,
        income_craft: 0,
        income_position: 0,
        income_special: 0,
        promptpay_number: "",
        not_cal_time: "0",
        payment_type: 0,
        last_name: "",
        nationality: "",
        emp_type: "0",
        earning_daytype: "0",
        daily_monday: 0,
        daily_tuesday: 0,
        daily_wednesday: 0,
        daily_thursday: 0,
        daily_friday: 0,
        daily_saturday: 0,
        daily_sunday: 0,
        daily_holiday: 0,
        earning_hourtype: "0",
        hour_monday: 0,
        hour_tuesday: 0,
        hour_wednesday: 0,
        hour_thursday: 0,
        hour_friday: 0,
        hour_saturday: 0,
        hour_sunday: 0,
        hour_holiday: 0,
        form_hour_1: 0,
        to_hour_1: 0,
        hourearning_1: 0,
        form_hour_2: 0,
        to_hour_2: 0,
        hourearning_2: 0,
        birth_date: "",
        address: "",
        gender: "male",
        phone_num: "",
        email: "",
        race: "",
        line_id: "",
        citizen_id: "",
        position: "",
        approver: localStorage._usercode,
        start_work_date: "",
        packing_date: "",
        status: "1",
        branch: "",
        faction: "",
        department: "",
        start_salary: 0,
        packing_salary: 0,
        daily_earnings: 0,
        hourly_earnings: 0,
        book_bank: "",
        bank_name: "",
        bank_code: "",
        shift_profile: "",
        conditions_profile: "",
        emp_images: [],
        taxsetting: {
          less_exp_rate: 50,
          less_exp_base: 100000,
          reduce_person: 60000,
          reduce_spouse: 0,
          reduce_child_rate: 0,
          reduce_child_base: 30000,
          reduce_parent_rate: 0,
          reduce_parent_base: 30000,
          reduce_handucap_rate: 0,
          reduce_handucap_base: 30000,
          reduce_insurance_base: 100000,
          reduce_insurance: 0,
          reduce_parent_insurance_base: 15000,
          reduce_parent_insurance: 0,
          reduce_inc_residence_base: 100000,
          reduce_inc_residence: 0,
          reduce_ltf: 0,
          reduce_long_insurance: 0,
          reduce_rmf: 0,
          reduct_name_1: "",
          reduct_name_2: "",
          reduct_name_3: "",
          reduct_name_4: "",
          reduct_name_5: "",
          reduct_name_6: "",
          reduct_name_7: "",
          reduct_name_8: "",
          reduct_name_9: "",
          reduct_name_10: "",
          reduct_value_1: 0,
          reduct_value_2: 0,
          reduct_value_3: 0,
          reduct_value_4: 0,
          reduct_value_5: 0,
          reduct_value_6: 0,
          reduct_value_7: 0,
          reduct_value_8: 0,
          reduct_value_9: 0,
          reduct_value_10: 0
        },
        creator_code: localStorage._usercode
      };
    },
    getProfilePlan() {
      this.profilePlan = [];
      SettingService.getProfileAllPlan()
        .then(res => {
          this.profilePlan = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileConditions() {
      this.profileConditions = [];
      SettingService.getProfileConditions()
        .then(res => {
          this.profileConditions = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          this.branch_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmpDetail(data) {
      EmployeeService.getEmployeeDetail(data)
        .then(res => {
          console.log(res.data);
          this.form_model = res.data;
          this.form_model.earning_daytype = res.data.earning_daytype + "";
          this.form_model.earning_hourtype = res.data.earning_hourtype + "";
          this.form_model.is_auto_ss = res.data.is_auto_ss + "";
          this.form_model.is_auto_tax = res.data.is_auto_tax + "";
          this.form_model.is_special = res.data.is_special + "";
          this.form_model.is_training = res.data.is_training + "";
          this.form_model.emp_type = res.data.emp_type + "";
          this.form_model.status = res.data.status + "";
          this.form_model.payment_type = res.data.payment_type + "";
          this.img = res.data.emp_images;
          if (this.form_model.taxsetting == null) {
            this.form_model.taxsetting = {
              less_exp_rate: 50,
              less_exp_base: 100000,
              reduce_person: 60000,
              reduce_spouse: 0,
              reduce_child_rate: 0,
              reduce_child_base: 30000,
              reduce_parent_rate: 0,
              reduce_parent_base: 30000,
              reduce_handucap_rate: 0,
              reduce_handucap_base: 30000,
              reduce_insurance_base: 100000,
              reduce_insurance: 0,
              reduce_parent_insurance_base: 15000,
              reduce_parent_insurance: 0,
              reduce_inc_residence_base: 100000,
              reduce_inc_residence: 0,
              reduce_ltf: 0,
              reduce_long_insurance: 0,
              reduce_rmf: 0,
              reduct_name_1: "",
              reduct_name_2: "",
              reduct_name_3: "",
              reduct_name_4: "",
              reduct_name_5: "",
              reduct_name_6: "",
              reduct_name_7: "",
              reduct_name_8: "",
              reduct_name_9: "",
              reduct_name_10: "",
              reduct_value_1: 0,
              reduct_value_2: 0,
              reduct_value_3: 0,
              reduct_value_4: 0,
              reduct_value_5: 0,
              reduct_value_6: 0,
              reduct_value_7: 0,
              reduct_value_8: 0,
              reduct_value_9: 0,
              reduct_value_10: 0
            };
          }
          if (
            this.form_model.weekends != "" &&
            this.form_model.weekends != null
          ) {
            let split = this.form_model.weekends.split(",");
            split.forEach(ele => {
              if (ele == "Sun") {
                this.weekend_sun = "1";
              } else if (ele == "Mon") {
                this.weekend_mon = "1";
              } else if (ele == "Tue") {
                this.weekend_tue = "1";
              } else if (ele == "Wed") {
                this.weekend_wed = "1";
              } else if (ele == "Thu") {
                this.weekend_thu = "1";
              } else if (ele == "Fri") {
                this.weekend_fri = "1";
              } else if (ele == "Sat") {
                this.weekend_sat = "1";
              }
            });
          } else {
            this.weekend_sun = "0";
            this.weekend_mon = "0";
            this.weekend_tue = "0";
            this.weekend_wed = "0";
            this.weekend_thu = "0";
            this.weekend_fri = "0";
            this.weekend_sat = "0";
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getHolidayPlanList() {
      SettingService.getHolidayPlanList()
        .then(res => {
          this.holidayProfile = res.data.content;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    uploadPic($event) {
      const elem = this.$refs.file1;
      elem.click();
    },
    readThisdata(inputValue, index) {
      const file = inputValue.files[0];
      const myReader = new FileReader();
      myReader.onloadend = e => {
        this.img = myReader.result;
      };
      myReader.readAsDataURL(file);
    },
    onChangePicture($event, index) {
      this.readThisdata($event.target, index);
    },
    getWeekendsAndImg() {
      this.form_model.weekends = "";
      let checkbox_week = [];

      if (this.weekend_sun == "1") {
        checkbox_week.push("Sun");
      }
      if (this.weekend_mon == "1") {
        checkbox_week.push("Mon");
      }
      if (this.weekend_tue == "1") {
        checkbox_week.push("Tue");
      }
      if (this.weekend_wed == "1") {
        checkbox_week.push("Wed");
      }
      if (this.weekend_thu == "1") {
        checkbox_week.push("Thu");
      }
      if (this.weekend_fri == "1") {
        checkbox_week.push("Fri");
      }
      if (this.weekend_sat == "1") {
        checkbox_week.push("Sat");
      }

      for (var i = 0; i < checkbox_week.length; i++) {
        if (i == 0) {
          this.form_model.weekends = checkbox_week[i];
        } else {
          this.form_model.weekends += "," + checkbox_week[i];
        }
      }

      this.form_model.emp_images = [];
      if (this.img != "") {
        var rep_img1 = this.img.replace("data:image/png;base64,", "");
        var rep_img2 = rep_img1.replace("data:image/gif;base64,", "");
        var rep_img3 = rep_img2.replace("data:image/jpg;base64,", "");
        var rep_img4 = rep_img3.replace("data:image/bmp;base64,", "");
        var rep_img5 = rep_img4.replace("data:image/jpeg;base64,", "");

        this.form_model.emp_images.push({
          image_file: rep_img5
        });
      }
    },
    onSave() {
      if (this.form_model.taxsetting.reduce_child_rate > 3) {
        this.form_model.taxsetting.reduce_child_rate = 3;
      }

      if (
        this.form_model.taxsetting.reduce_insurance >
        this.form_model.taxsetting.reduce_insurance_base
      ) {
        this.form_model.taxsetting.reduce_insurance = this.form_model.taxsetting.reduce_insurance_base;
      }

      if (
        this.form_model.taxsetting.reduce_parent_insurance >
        this.form_model.taxsetting.reduce_parent_insurance_base
      ) {
        this.form_model.taxsetting.reduce_parent_insurance = this.form_model.taxsetting.reduce_parent_insurance_base;
      }

      if (
        this.form_model.taxsetting.reduce_inc_residence >
        this.form_model.taxsetting.reduce_inc_residence_base
      ) {
        this.form_model.taxsetting.reduce_inc_residence = this.form_model.taxsetting.reduce_inc_residence_base;
      }

      this.form_model.company_guid = localStorage._company_guid;

    if(this.user_name2 != ""){
            this.form_model.user_name = this.user_name2
       }else if(this.user_name2 == ""){
          this.form_model.user_name = this.form_model.user_name
       }
      if (this.form_model.code == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มรหัสพนักงาน";
      } else if (this.form_model.citizen_id == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มเลขบัตรประจำประชาชน";
      } else if (this.form_model.first_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มชื่อพนักงาน";
      } else if (this.form_model.last_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มนามสกุลพนักงาน";
      }else if (this.form_model.start_work_date == "") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกวันที่เริ่มงาน";
      }else if (this.form_model.start_salary == 0) {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกเงินเดือนเริ่มต้น";
      }else if (this.form_model.user_name == "" && this.form_model.user_password != "" ) {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกชื่อผู้ใช้ระบบ";
      }else if (this.form_model.user_name != "" && this.form_model.user_password == "" ) {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกรห้สผ่าน";
      }else {
        if (this.form_valid) {
          this.getWeekendsAndImg();

          console.log(this.form_model);

          EmployeeService.createEmployee(this.form_model)
            .then(res => {
              this.snackbar = true;
              this.errmsg = "กรุณากรอกรห้สผ่าน";
              //this.closeDialog();
            })
            .catch(err => {
              console.log(err);
              this.snackbar = true;
              this.errmsg = err;
            });
        }
      }
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    onUpdate() {
      if (this.form_model.taxsetting.reduce_child_rate > 3) {
        this.form_model.taxsetting.reduce_child_rate = 3;
      }

      if (
        this.form_model.taxsetting.reduce_insurance >
        this.form_model.taxsetting.reduce_insurance_base
      ) {
        this.form_model.taxsetting.reduce_insurance = this.form_model.taxsetting.reduce_insurance_base;
      }

      if (
        this.form_model.taxsetting.reduce_parent_insurance >
        this.form_model.taxsetting.reduce_parent_insurance_base
      ) {
        this.form_model.taxsetting.reduce_parent_insurance = this.form_model.taxsetting.reduce_parent_insurance_base;
      }

      if (
        this.form_model.taxsetting.reduce_inc_residence >
        this.form_model.taxsetting.reduce_inc_residence_base
      ) {
        this.form_model.taxsetting.reduce_inc_residence = this.form_model.taxsetting.reduce_inc_residence_base;
      }

       this.form_model.company_guid = localStorage._company_guid;
       if(this.user_name2 != ""){
            this.form_model.user_name = this.user_name2
       }else if(this.user_name2 == ""){
          this.form_model.user_name = this.form_model.user_name
       }
      

      if (this.form_model.code == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มรหัสพนักงาน";
      } else if (this.form_model.citizen_id == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มเลขประจำตัว";
      } else if (this.form_model.first_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มชื่อพนักงาน";
      } else if (this.form_model.last_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มนามสกุลพนักงาน";
      }else if (this.form_model.start_work_date == "") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกวันที่เริ่มงาน";
      }else {
         this.dialog_loading = true;
        if (this.form_valid) {
          this.getWeekendsAndImg();

          console.log(this.form_model);

          EmployeeService.updateEmployee(this.form_model)
            .then(res => {
              this.dialog_loading = false;
              this.snackbar_success = true;
              this.errmsg = "บันทึกข้อมูลส่วนตัวสำเร็จ";
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,label,
span,h3,strong,
p {
  font-family: "Prompt", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}

.v-card__text {
  padding-top: 0;
}
.v-toolbar__title{
  font-family: "Prompt", sans-serif;
}
</style>
<style type="text/css">
@keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@-webkit-keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@-webkit-keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
@-webkit-keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
.lds-pacman {
  position: relative;
}
.lds-pacman > div:nth-child(2) div {
  position: absolute;
  top: 40px;
  left: 40px;
  width: 120px;
  height: 60px;
  border-radius: 120px 120px 0 0;
  background: #3be8ce;
  -webkit-animation: lds-pacman-1 0.9s linear infinite;
  animation: lds-pacman-1 0.9s linear infinite;
  -webkit-transform-origin: 60px 60px;
  transform-origin: 60px 60px;
}
.lds-pacman > div:nth-child(2) div:nth-child(2) {
  -webkit-animation: lds-pacman-2 0.9s linear infinite;
  animation: lds-pacman-2 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div {
  position: absolute;
  top: 92px;
  left: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1ec7ed;
  -webkit-animation: lds-pacman-3 0.9s linear infinite;
  animation: lds-pacman-3 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div:nth-child(1) {
  -webkit-animation-delay: -0.603s;
  animation-delay: -0.603s;
}
.lds-pacman > div:nth-child(1) div:nth-child(2) {
  -webkit-animation-delay: -0.297s;
  animation-delay: -0.297s;
}
.lds-pacman > div:nth-child(1) div:nth-child(3) {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.lds-pacman {
  width: 200px !important;
  height: 200px !important;
  -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}
</style>